import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import OptionMenuToggle from "../theme_reuse/OptionMenuToggle";
import HistoryAutoScrollButton from "../music_controls/custom_buttons/HistoryAutoScrollButton";

interface Props {}
interface State {}

const TITLE = "Automatic Scrolling?";
const shortNames = [false, true];
const descriptions = ["You control the scrollbar.", "While recording or replaying, automatically keep the current time in view."];

function printShortName(x: boolean): string {
  switch (x) {
    case true:
      return "On";
    case false:
      return "Off";
  }
}

export default class NoteHideOctaveToggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeSetting = (autoScroll: boolean) => {
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { autoScroll } });
  };

  render(): ReactNode {
    const setting = this.context.chordHistoryOptions.autoScroll;
    return (
      <OptionMenuToggle
        title={TITLE}
        optionShortNames={shortNames}
        optionDescriptions={descriptions}
        selected={setting}
        printShortName={printShortName}
        onChange={this.changeSetting}
        extraInfo={
          <p>
            Shortcut: hold shift and press I, or press the <HistoryAutoScrollButton /> button.
          </p>
        }
      />
    );
  }
}

NoteHideOctaveToggle.contextType = AppContextType;
